moment.fn.formatWCP = function () {
   return this.format("MMM D, YYYY").valueOf();
};